import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-exclamation",
  "use": "icon-exclamation-usage",
  "viewBox": "0 0 4 12",
  "content": "<symbol viewBox=\"0 0 4 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-exclamation\">\n<path d=\"M3.20312 3.44531L2.57031 8.82031H1.40625L0.757812 3.44531V0.523438H3.20312V3.44531ZM3.14062 9.74219V12H0.8125V9.74219H3.14062Z\" fill=\"#DD6868\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol